module.exports = __webpack_public_path__ + "img/toyota-used.2fd9ed87.png";